export const TRIGGER_TYPES = {
  MANUAL: 'Manual'
};